import { SentimentIcon } from "./SentimentIcon";
import { Formatter } from "./format";
import {Tag} from "./Tag";
import { Box } from '@cloudscape-design/components';
import "../AiPage.scss";


function timeToSeconds(timeStr) {
  const [hours, minutes, seconds] = timeStr.split(':').map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}
const getTranscriptDetails = (allSegments) => {
  let offsetStartValue = 0;
  let offsetEndValue = 0;
  return allSegments.reduce((accumulator, item) => {
    offsetStartValue = offsetEndValue === 0 ? offsetEndValue : offsetEndValue + 1;
    offsetEndValue = offsetStartValue + item?.Text.trim().length;
    
    accumulator =[...accumulator,{content: item.Text.trim(), start: item.StartTime, end: item.EndTime, confidence: item.Confidence, offsetStart: offsetStartValue, offsetEnd: offsetEndValue}];
    return accumulator;
  },[]);
}

const generateTranscriptElement = (text, allSegments, highlightLocations, onClick, timeMoment) => {
  if (!allSegments.length) {
    return applyReplacements(text, highlightLocations);
  }
  const transcript = getTranscriptDetails(allSegments);
  
  return  transcript.map((segment, i) => {
    const addHighlight = highlightLocations.filter(highlight => highlight.start === segment.offsetStart || highlight.end === segment.offsetEnd || (highlight.start <= segment.offsetStart && highlight.end >= segment.offsetEnd) || (highlight.end >= segment.offsetStart && highlight.end <= segment.offsetEnd));
    let content = segment.content + " " ;
    const key = "segment-"+ segment.offsetStart;

    let textStyle = {};
    let tooltip = "";

    if (segment.confidence < 0.5) {
      textStyle = { color: "red", opacity: 0.9 }; // Strikethrough for low confidence
      content = `[${content.trim()}]` + " "; // Wrap content in brackets
      tooltip = `Very low confidence transcription: ${segment.confidence.toFixed(2)*100}%`;
    } else if (segment.confidence < 0.7) {
      textStyle = { color: "orange", opacity: 1, textDecoration: "underline dotted"}; // Dotted underline or brackets
      tooltip = `Low confidence transcription: ${segment.confidence.toFixed(2)*100}%`;
    } else if (segment.confidence < 0.9) {
      textStyle = { fontStyle: "italic", color: "purple", opacity:0.6 }; // Italic for moderate confidence
      tooltip = `Medium confidence transcription: ${segment.confidence.toFixed(2)*100}%`;
    }

    //console.log(segment.start, segment.end,  typeof segment.end,timeToSeconds(timeMoment), typeof timeToSeconds(timeMoment), parseFloat(segment.start) > parseFloat(timeToSeconds(timeMoment)) && parseFloat(segment.end) < parseFloat(timeToSeconds(timeMoment)) && timeMoment !== '');
    let addFlag = false;
    if (
      parseFloat(timeToSeconds(timeMoment)) >= parseFloat(segment.start) &&
      parseFloat(timeToSeconds(timeMoment)) <= parseFloat(segment.end)
    ) {
      addFlag = true;
    } else {
      addFlag = false
    }
    

    if(addHighlight.length) {
      <>
      {addFlag && <span id={timeToSeconds(timeMoment)} style={{ height: '20px', minWidth: '5px', background: 'rgb(250, 100, 73)', display: "inline-block", marginRight: '4px', fontSize: "10px", padding: '0px', color: 'white', borderRadius: '6px'}} >moment</span>}
      
      <span
          onClick={onClick}
          key={key}
          className="word_conversation"
        >
          {addHighlight[0].fn(content, key, segment.start, segment.end, segment.offsetStart, segment.offsetEnd)}
        </span>
      </>
    }
    return <span
    onClick={onClick}
    data-start={segment.start}
    data-end={segment.end}
    data-offset-start={segment.offsetStart}
    data-offset-end={segment.offsetEnd}
    key={key}
    style={{ cursor: 'pointer', ...textStyle }}
    className="word_conversation"
    title={tooltip || undefined}
  >
    {addFlag && <span id={timeToSeconds(timeMoment)} style={{ height: '20px', minWidth: '5px', background: 'rgb(250, 100, 73)', display: "inline-block", marginRight: '4px', fontSize: "10px", padding: '0px 10px', color: 'white', borderRadius: '6px'}} >moment</span>}
    {content}
  </span>
  });
}

export const TranscriptSegment = ({
  name,
  allSegments,
  segmentStart,
  text,
  onClick,
  highlightLocations,
  score,
  interruption,
  ivr,
  categoryList,
  timeMoment
}) => (
  <div style={{display:"flex", paddingBottom:"1rem"}}>
    <div style={{margin: "0.4rem"}}>
      <SentimentIcon score={score} size="2em" />
    </div>
    <div>
      <span className={"text-muted segment"}>
        {name} -{" "}
        <span
          className="audio-start"
          data-currenttime={segmentStart}
        >
          {Formatter.Time(segmentStart)}
        </span>
      </span>
      {ivr && (
        <Tag key="ivr" bg="danger" className="ms-2">
          IVR
        </Tag>
      )}
      {interruption && (
        <Tag key="warning" bg="warning" text="dark" className="ms-2">
          Interruption
        </Tag>
      )}
      {categoryList.length > 0 && (
        categoryList.map((category, j) => (
              <Tag key={j} bg="primary" className="ms-2">
                {category}
              </Tag>
            )
          )
        )}
      <div>{generateTranscriptElement(text, allSegments, highlightLocations, onClick, timeMoment)}</div>
    </div>
  </div>
);

// substituteAt replaces a subset of a string with the value of the fn provided.
// it returns an array containing string and react elements
const substituteAt = (input, beginOffset, endOffset, fn, key) => {
  let before = input.slice(0, beginOffset);
  let after = input.slice(endOffset);

  const target = input.slice(beginOffset, endOffset);
  const replaced = fn(target, key);
  return [before, replaced, after];
};

const wrapper = (input, ...opts) => {
  if (!Array.isArray(input)) input = [input];

  return input
    .map((chunk, i) =>
      typeof chunk === "string" && i === 0
        ? substituteAt(chunk, ...opts)
        : chunk
    )
    .flat();
};

// applyReplacements applies a series of string replacements to the input.
// each replacement should consist of a start offset, end offset and
// function that transforms the target string
// Substrings identified by start and end offsets cannot overlap
export const applyReplacements = (input, replacements) =>
  replacements
    .sort(sortFn)
    .reduceRight(
      (accumulator, { start, end, fn }, i) =>
        wrapper(accumulator, start, end, fn, i),
      input
    );

const sortFn = (a, b) => {
  if (a.start > b.start) return 1;
  if (a.start < b.start) return -1;
  return 0;
};
